import { Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ShHtmlParserComponent } from '../../../../../core/html-parser/html-parser.component';
import { ShListRowTitleComponent } from '../../../../../elements/components/list-row-title/list-row-title.component';
import { ShBaseCell } from '../_base/base-cell.component';
import { TextCell } from './text-cell.entity';

@Component({
    standalone: true,
    selector: 'sh-text-cell',
    templateUrl: './text-cell.component.html',
    imports: [CommonModule, ShListRowTitleComponent, ShHtmlParserComponent]
})
export class ShTextCellComponent extends ShBaseCell {
    @Input() public cell!: TextCell;
}
